import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaStar, FaUserCircle } from "react-icons/fa";

const Review = () => {
  const [reviews, setReviews] = useState([]);
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(5);
  const [hasReviewed, setHasReviewed] = useState(false);
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(() => {
    if (user) {
      axios.get(`${process.env.REACT_APP_API_URL}/get-reviews`).then((res) => {
        const found = res.data.reviews.find((r) => r.user_id === user.id);
        setHasReviewed(!!found);
      });
    }
  }, [user]);

  const fetchReviews = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/get-reviews`)
      .then((res) => setReviews(res.data.reviews))
      .catch((err) => console.error("Error fetching reviews:", err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!token || !user) {
      Swal.fire(
        "Login Required",
        "Please login to submit a review!",
        "warning"
      );
      return;
    }

    if (hasReviewed) {
      Swal.fire("Oops!", "You've already submitted a review.", "info");
      return;
    }

    axios
      .post(`${process.env.REACT_APP_API_URL}/add-review`, {
        user_id: user.id,
        rating,
        comment,
      })
      .then((res) => {
        Swal.fire("Success", "Review submitted!", "success");
        setComment("");
        fetchReviews();
        setHasReviewed(true);
      })
      .catch((err) => {
        Swal.fire(
          "Error",
          err.response?.data?.message || "Failed to submit",
          "error"
        );
      });
  };

  return (
    <div className="container my-5 p-5" style={{backgroundColor:'aliceblue'}}>
      <h2 className="text-primary text-center mb-4">User Reviews</h2>

      <div className="row">
        {/* Form */}
        <div className="col-md-6 mb-4">
          <div className="card shadow p-4 border-0">
            <h4 className="text-secondary mb-3">Add Your Review</h4>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-bold mb-2">Rating</label>
                <select
                  className="form-select"
                  value={rating}
                  onChange={(e) => setRating(e.target.value)}
                  required
                >
                  {[5, 4, 3, 2, 1].map((num) => (
                    <option key={num} value={num}>
                      {"⭐".repeat(num)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold mb-2">Comment</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Share your experience..."
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100 fw-bold mt-3">
                Submit Review
              </button>
            </form>
          </div>
        </div>

        {/* Reviews List */}
        <div className="col-md-6" style={{maxHeight:400, overflowY:'scroll'}}>
          {reviews.length > 0 ? (
            reviews.map((review) => (
              <div className="card mb-3 shadow-sm border-0" key={review.id}>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-2">
                    <FaUserCircle className="me-2 text-secondary" size={22} />
                    <strong className="me-2">{review.user_name}</strong>
                    <span className="text-warning">
                      {Array(review.rating)
                        .fill()
                        .map((_, i) => (
                          <FaStar key={i} />
                        ))}
                    </span>
                  </div>
                  <p className="text-muted mb-0">{review.comment}</p>
                  <small className="text-secondary">
                    {new Date(review.created_at).toLocaleString()}
                  </small>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted">No reviews yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Review;
